export const constants = {
    regex_patterns: {
        location: /(([A-Z]*[a-z]*[0-9]*[' ']*)*\,[' ']*([A-Z]*[a-z]*[0-9]*[' ']*)*\,[' ']*([A-Z]*[a-z]*[0-9]*[' ']*)*)+/,
        important: /(([A-Z]+[a-z]+)+\,([' ']*([A-Z]*[a-z]*)*)*\,([' ']*([A-Z]+[a-z]+)+)*)+/,
        emptyString: /^\s*$/,
        manualScreen: /([A-Z]+[a-z]+[ ]*[A-Z]*[a-z]*)+\,([ ]*([A-Z]*[a-z]*[ ]*[A-Z]*[a-z]*)*)*\,([A-Z]+[a-z]+[ ]*[A-Z]*[a-z]*)+/,
        emptyVendorName: /^\s*$/
    }
}